
import request from '../request'
import apis from '../apis'

export default {

    /**
    * 获取首页展会列表
    * @param {*} data
    */
    getExhiHomeList(data) {
        return request.get(`${apis.GET_EXHI_LIST}/${data.pageSize}/${data.curPage}`, { params: data.params });
    },

    /**
    * 获取热门酒店轮播图展示
    * @param {*} data
    */
    getHotHotel(data) {
        return request.get(apis.GET_HOT_HOTEL, { params: data })
    },

    /**
    * 获取资源首页展会配置
    * @param {*} data
    */
    getResExhiConfig(data) {
        return request.get(apis.GET_RES_EXHI_CONFIG, { params: data });
    },

    /**
    * 获取资源首页业务锁
    * @param {*} data
    */
    getResBusinessLock(data) {
        return request.get(apis.GET_RES_BUSINESS_LOCK, { params: data });
    }
}
